export default __webpack_public_path__ + "static/media/angry-cats.98bb3f15.webp";